<template>
  <div class="PersonIdentity">
    <Avatar
      :name
      :size
      :active
      :disabled
    />

    <div class="PersonIdentity-info">
      <span class="PersonIdentity-name">
        <slot name="name">
          {{ name }}
        </slot>
      </span>

      <span class="PersonIdentity-description">
        <slot name="description">
          {{ description }}
        </slot>

        <slot name="extra" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import Avatar from '../../atoms/Avatar/Avatar.vue';
import type { PersonIdentityProps } from './PersonIdentity.model';

withDefaults(defineProps<PersonIdentityProps>(), {
  size: 'md',
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;

@layer cvo-ui {
  .PersonIdentity {
    display: flex;
    align-items: center;
    gap: vars.$dimensions-d-2;
    flex: 1 0 0;
    min-width: 0;

    &-info {
      display: flex;
      flex: 1 0 0;
      flex-direction: column;
      align-items: flex-start;
      gap: vars.$dimensions-d-1;
      min-width: 0;
    }

    &-description {
      display: inline-flex;
      align-items: center;
      gap: vars.$dimensions-d-1;
    }

    // -name and -description styles are provided by parent components
    // since they all have specific tokens depending on where it's used.
  }
}
</style>
